/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Benchmark_LedeInputs */

const en_platform_benchmark_lede = /** @type {(inputs: Platform_Benchmark_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every call through AnyAPI over the last 30 days, counted here rather than promised.`)
};

const zh_hans1_platform_benchmark_lede = /** @type {(inputs: Platform_Benchmark_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过去 30 天经由 AnyAPI 的每一次调用，都在这里如实统计，而不是空口承诺。`)
};

const pt_br2_platform_benchmark_lede = /** @type {(inputs: Platform_Benchmark_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada chamada feita pela AnyAPI nos últimos 30 dias, contada aqui em vez de prometida.`)
};

const es_platform_benchmark_lede = /** @type {(inputs: Platform_Benchmark_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada llamada a través de AnyAPI en los últimos 30 días, contada aquí en lugar de prometida.`)
};

const fr_platform_benchmark_lede = /** @type {(inputs: Platform_Benchmark_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque appel passé par AnyAPI ces 30 derniers jours, compté ici plutôt que promis.`)
};

const de_platform_benchmark_lede = /** @type {(inputs: Platform_Benchmark_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Aufruf über AnyAPI in den letzten 30 Tagen, hier gezählt statt versprochen.`)
};

const ru_platform_benchmark_lede = /** @type {(inputs: Platform_Benchmark_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все вызовы через AnyAPI за последние 30 дней: они посчитаны здесь, а не обещаны.`)
};

const it_platform_benchmark_lede = /** @type {(inputs: Platform_Benchmark_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni chiamata passata da AnyAPI negli ultimi 30 giorni, contata qui e non promessa.`)
};

/**
* | output |
* | --- |
* | "Every call through AnyAPI over the last 30 days, counted here rather than promised." |
*
* @param {Platform_Benchmark_LedeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_benchmark_lede = /** @type {((inputs?: Platform_Benchmark_LedeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Benchmark_LedeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_benchmark_lede(inputs)
	if (locale === "pt-BR") return pt_br2_platform_benchmark_lede(inputs)
	if (locale === "es") return es_platform_benchmark_lede(inputs)
	if (locale === "fr") return fr_platform_benchmark_lede(inputs)
	if (locale === "de") return de_platform_benchmark_lede(inputs)
	if (locale === "ru") return ru_platform_benchmark_lede(inputs)
	if (locale === "it") return it_platform_benchmark_lede(inputs)
	return en_platform_benchmark_lede(inputs)
});